var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0948 12.3113L12.3112 21.0948C11.1043 22.3017 9.14748 22.3017 7.94055 21.0948L2.9052 16.0595C1.69827 14.8525 1.69827 12.8957 2.9052 11.6888L11.6887 2.90524C12.3945 2.19948 13.3976 1.878 14.3822 2.04209L19.424 2.8824C20.2924 3.02713 20.9729 3.70762 21.1176 4.57601L21.9579 9.61785C22.122 10.6024 21.8005 11.6055 21.0948 12.3113ZM17.5164 9.17108C16.7743 9.9132 15.571 9.9132 14.8289 9.17108C14.0868 8.42897 14.0868 7.22576 14.8289 6.48364C15.571 5.74153 16.7743 5.74153 17.5164 6.48364C18.2585 7.22576 18.2585 8.42897 17.5164 9.17108Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.26064e7151810dc76c72e5fc456a3170.svg";
export { ForwardRef as ReactComponent };